import { useEffect } from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import * as Sentry from '@sentry/react';

export function useSentryUser(): void {
  const { user, isAuthenticated } = useAuth0();

  // Depend on stable primitive fields instead of the `user` object: Auth0
  // returns a fresh reference on every render, which would otherwise fire
  // this effect (and `Sentry.setUser`) on each render.
  const id = user?.sub;
  const email = user?.email;
  const username = user?.nickname ?? user?.name;

  useEffect(() => {
    if (isAuthenticated && id) {
      Sentry.setUser({ id, email, username });
    } else {
      Sentry.setUser(null);
    }
  }, [isAuthenticated, id, email, username]);
}
